import React from 'react'
import {FieldArray, FormSection} from 'redux-form'
import {Section, TextField, TextAreaField, DateField, BoxDouble} from 'jbc-front/components/Form'
import {LabelMapper} from 'jbc-front/components/FormErrors'
import {PlusSquare, DeleteSquare} from 'jbc-front/components/icons'
import {connect} from 'react-redux'
import {Description, withFormSelectors} from 'employees/form/common'
import moment from 'moment'
import * as validators from 'jbc-front/utils/validators'
import {set} from 'lodash'
import styles from 'employees/Form.scss'
import {flow} from 'lodash/fp'

const renderEmployeeProjectComponent = ({fields, index, name, diff = {}}) => (
  <li>
    <LabelMapper name="employee_projects" label="プロジェクトの" />
    <Section
      title={`プロジェクト (${index + 1})`}
      key={index}
      icon={
        <DeleteSquare
          onClick={() => {
            fields.remove(index)
          }}
        />
      }
    >
      <FormSection name={name}>
        <TextField
          name="project_name"
          label="プロジェクト名"
          validate={validators.maxLength(32)}
          diff={diff.project_name}
          required
        />
        <BoxDouble>
          <div className={styles.arrayDoubleDate}>
            <DateField name="start_date" label="開始年月日" diff={diff.start_date} />
          </div>
          <div className={styles.arrayDoubleDate}>
            <DateField name="end_date" label="終了年月日" diff={diff.end_date} />
          </div>
        </BoxDouble>
        <TextAreaField
          name="project_details"
          label="プロジェクト詳細"
          validate={validators.maxLength(255)}
          diff={diff.project_details}
          rows="4"
        />
      </FormSection>
    </Section>
  </li>
)

const EmployeeProjectComponent = connect((state, {index, selector}) => ({
  startDate: selector(state, `employee_projects[${index}].start_date`),
  endDate: selector(state, `employee_projects[${index}].end_date`),
}))(renderEmployeeProjectComponent)

export const renderProjrect = ({fields, selector, diff = []}) => (
  <div>
    <LabelMapper name="employee_projects" label="プロジェクトの" />
    <ul>
      {fields.map((name, index) => (
        <EmployeeProjectComponent
          diff={diff[index]}
          {...{
            index,
            name,
            fields,
            selector,
          }}
          key={index}
        />
      ))}
    </ul>
    {fields.length < 1 && (
      <div className="u-ta-c">
        <p>
          「プロジェクトを追加」ボタンを押して、
          <br />
          プロジェクトを追加してください。
        </p>
      </div>
    )}
    <div className="u-ta-r u-mt20">
      <div onClick={() => fields.push({})} className="u-txt-addinfo">
        <PlusSquare size={20} className="u-txt-addinfo-icon" />
        プロジェクトを追加
      </div>
    </div>
  </div>
)

const EmployeeProject = ({selector, description, description_color_by_rgb, diff = {}}) => {
  return (
    <Section title="プロジェクト">
      <Description {...{description, description_color_by_rgb}} />
      <FieldArray name="employee_projects" component={renderProjrect} diff={diff.employee_projects} {...{selector}} />
    </Section>
  )
}

export default flow(
  connect((state, {selector}) => ({
    diff: selector(state, '_diff'),
  })),
  withFormSelectors
)(EmployeeProject)

const validatePeriods = ({name, startColumn, endColumn}, values) => {
  const periods = values[name]
  if (!periods) {
    return {}
  }

  const errors = {}
  periods.forEach((period, index) => {
    const startOn = period[startColumn] ? moment(period[startColumn]) : null
    const endOn = period[endColumn] ? moment(period[endColumn]) : null
    if (startOn && endOn && startOn.isAfter(endOn)) {
      set(errors, `${name}[${index}].${endColumn}`, 'は正しくありません')
    }
  })
  return errors
}

export const validate = (values) => {
  return Object.assign(
    {},
    validatePeriods({name: 'employee_projects', startColumn: 'start_date', endColumn: 'end_date'}, values)
  )
}
